import { render, staticRenderFns } from "./BrandPartsGroup.vue?vue&type=template&id=e4aa50ae&scoped=true&"
import script from "./BrandPartsGroup.vue?vue&type=script&lang=js&"
export * from "./BrandPartsGroup.vue?vue&type=script&lang=js&"
import style0 from "./BrandPartsGroup.vue?vue&type=style&index=0&id=e4aa50ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4aa50ae",
  null
  
)

export default component.exports